import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Checkbox, MultiColumnList } from '@folio/stripes/components';
import { FormattedMessage } from 'react-intl';
import EmptyData from './emptyData/EmptyData';
import ResultsTabs from './ResultsTabs';
import { columnMapping, sortedVisibleColumns } from '../../../utils/utils';

function ResultsPreview({
  selectedSources,
  visibleColumns,
  cartList,
  showCartList,
  contentData,
  currentTab,
  selection,
  setSelection,
  setcurrentTab,
  currentPage,
  pageSize,
  setShowRecordPane,
  selectedItem,
  setSelectedItem,
}) {
  const [sortedColumn, setSortedColumn] = useState('serverName');
  const [allColumns, setAllColumns] = useState([]);

  useEffect(() => {
    if (selectedSources.length > 1) {
      if (currentTab === 'All') {
        setAllColumns([
          'rowIndex',
          'selected',
          'serverName',
          'title',
          ...visibleColumns.sort(
            (a, b) => sortedVisibleColumns.indexOf(a) - sortedVisibleColumns.indexOf(b),
          ),
        ]);
      } else {
        setAllColumns([
          'rowIndex',
          'selected',
          'title',
          ...visibleColumns.sort(
            (a, b) => sortedVisibleColumns.indexOf(a) - sortedVisibleColumns.indexOf(b),
          ),
        ]);
      }
    } else {
      setAllColumns([
        'rowIndex',
        'selected',
        'title',
        ...visibleColumns.sort(
          (a, b) => sortedVisibleColumns.indexOf(a) - sortedVisibleColumns.indexOf(b),
        ),
      ]);
    }
  }, [currentTab, selectedSources, visibleColumns]);

  useEffect(() => {
    if (contentData.length !== Object.values(selection).length) {
      const selectionData = {};
      contentData.forEach((item) => {
        selectionData[item.id] = false;
      });
      setSelection(selectionData);
    }
  }, [contentData, cartList]);

  useEffect(() => {
    if (Object.values(selection).includes(true)) {
      setSelectedItem({});
    }
  }, [selection]);

  const onToggleBulkSelection = () => {
    const select = Object.values(selection).includes(false);
    const selectionData = {};

    contentData.forEach((item) => {
      selectionData[item.id] = select;
    });
    setSelection(selectionData);
  };

  const onToggleSelection = (item) => {
    setSelection({
      ...selection,
      [item.id]: !selection[item.id],
    });
  };

  return (
    <>
      {selectedSources.length > 1 && !showCartList && (
        <ResultsTabs
          currentTab={currentTab}
          setcurrentTab={setcurrentTab}
          tabsList={selectedSources}
        />
      )}
      <MultiColumnList
        key={currentTab}
        id="copycat-results-preview-multi-column-list"
        interactive={false}
        sortedColumn={sortedColumn}
        sortDirection="ascending"
        selectedRow={selectedItem}
        onHeaderClick={(e, { name }) => setSortedColumn(name)}
        visibleColumns={allColumns}
        contentData={contentData}
        onRowClick={(e, item) => {
          if (Object.values(selection).includes(true)) {
            return;
          }
          setShowRecordPane(true);
          setSelectedItem(item);
        }}
        columnMapping={{
          ...columnMapping,
          selected: (
            <Checkbox
              name="selected-all"
              checked={Object.values(selection).includes(false) !== true}
              onChange={onToggleBulkSelection}
              onMouseDown={(e) => e.preventDefault()}
            />
          ),
        }}
        columnWidths={{
          rowIndex: '5%',
          selected: '5%',
          serverName: '10%',
          title: '25%',
          author: '17%',
          ISBN: '10%',
          edition: '10%',
          publisher: '10%',
          publicationYear: '8%',
        }}
        formatter={{
          rowIndex: (item) => currentPage * pageSize - pageSize + (item.rowIndex + 1),
          serverName: (item) => (
            <FormattedMessage
              id={`ui-inventory.targetProfiles.name.${item.serverName}`}
              defaultMessage={item.serverName}
            />
          ),
          selected: (item) => (
            <Checkbox
              name="selected-all"
              checked={!!selection[item.id]}
              onChange={() => {
                onToggleSelection(item);
              }}
              onMouseDown={(e) => e.preventDefault()}
            />
          ),
        }}
        autosize
        virtualize={false}
        isEmptyMessage={<EmptyData />}
      />
    </>
  );
}

ResultsPreview.propTypes = {
  selectedSources: PropTypes.arrayOf(PropTypes.object),
  visibleColumns: PropTypes.arrayOf(PropTypes.string),
  cartList: PropTypes.arrayOf(PropTypes.object),
  showCartList: PropTypes.bool,
  contentData: PropTypes.arrayOf(PropTypes.object),
  currentTab: PropTypes.string,
  setSelection: PropTypes.func,
  selection: PropTypes.object,
  setcurrentTab: PropTypes.func,
  currentPage: PropTypes.number,
  pageSize: PropTypes.number,
  setShowRecordPane: PropTypes.func,
  selectedItem: PropTypes.object,
  setSelectedItem: PropTypes.func,
};

export default ResultsPreview;
